import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function UpgradeBanner({ feature }) {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  if (!user || user.plan !== "free") return null;
  return (
    <div style={{
      background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
      borderRadius: 10,
      padding: "12px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 24,
      flexWrap: "wrap",
      gap: 10
    }}>
      <div style={{ color: "#fff" }}>
        <span style={{ fontSize: 14, fontWeight: 700 }}>🚀 Débloquez tout avec Pro</span>
        <span style={{ fontSize: 13, marginLeft: 10, opacity: 0.9 }}>
          {feature || "Analyses illimitées, export PDF, historique 1 an, 500 keywords"}
        </span>
      </div>
      <button
        onClick={() => navigate("/pricing")}
        style={{
          background: "#fff",
          color: "#6366f1",
          border: "none",
          borderRadius: 6,
          padding: "7px 16px",
          fontSize: 13,
          fontWeight: 700,
          cursor: "pointer",
          whiteSpace: "nowrap"
        }}>
        Upgrade → €29/mois
      </button>
    </div>
  );
}
